import { provideAppInitializer } from '@angular/core';
declare global {
  interface Window {
    fbAsyncInit: () => void;
    FB: any;
  }
}
/**
 * Provides an initializer that loads the Facebook SDK before the app fully boots.
 * Uses `provideAppInitializer`, which is the modern replacement for `APP_INITIALIZER`.
 * The returned Promise resolves once `FB.init` is called and `getLoginStatus` completes (or times out).
 *
 * @returns An `EnvironmentProviders` setup that Angular runs on boot.
 */
export const facebookSdkInitializer = provideAppInitializer(() => {
  return new Promise<void>((resolve) => {
    // If FB is already loaded (e.g., hot reload), re-init safely
    if (window.FB) {
      try {
        window.FB.init({
          appId: '2875235076007400',
          cookie: true,
          xfbml: false,
          version: 'v16.0',
        });
      } catch (err) {
        console.error('Error on FB.init (already loaded):', err);
      }
      window.FB.getLoginStatus(() => {
        resolve();
      });
    } else {
      // Define global callback for when FB SDK loads
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: '2875235076007400',
          cookie: true,
          xfbml: false,
          version: 'v16.0',
        });
        window.FB.getLoginStatus(() => {
          resolve();
        });
      };

      // Dynamically insert the SDK script tag
      (function (d, s, id) {
        const js = d.createElement(s) as HTMLScriptElement;
        js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk.js';
        const fjs = d.getElementsByTagName(s)[0];
        fjs.parentNode?.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    }

    // Timeout fallback in case SDK fails to load in reasonable time
    setTimeout(() => {
      if (!window.FB) {
        console.warn(
          'Facebook SDK did not load in time (timeout). Proceeding without it.'
        );
      }
      resolve();
    }, 10_000);
  });
});
